import React, { useEffect, useRef } from "react";

interface ContextMenuProps {
  show: boolean;
  setShow: (visible: boolean) => void;
  position: { x: number; y: number };
  options: { label: string; icon?: React.ReactNode; action: () => void }[];
}

export const ContextMenu = (props: ContextMenuProps) => {
  const { show, setShow, position, options } = props;
  const rootRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (rootRef.current && !rootRef.current.contains(event.target as Node)) {
        setShow(false);
      }
    };
    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [setShow]);

  return show ? (
    <div
      ref={rootRef}
      className="contextMenu"
      style={{
        top: `${position.y}px`,
        left: `${position.x}px`,
        position: "fixed",
      }}
    >
      {options.map((option, index) => (
        <div
          key={index}
          className="contextMenu-option"
          onClick={() => {
            option.action();
            setShow(false);
          }}
        >
          {option.icon && <span className="icon">{option.icon}</span>}
          {option.label}
        </div>
      ))}
    </div>
  ) : (
    <></>
  );
};
